import { render, staticRenderFns } from "./SupplierSaleProductsList.vue?vue&type=template&id=533b6040&scoped=true"
import script from "./SupplierSaleProductsList.vue?vue&type=script&lang=js"
export * from "./SupplierSaleProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b6040",
  null
  
)

export default component.exports